const baseurl="http://127.0.0.1:8000"
export default {
      baseurl
}


// WEBPACK FOOTER //
// ./src/api/global.js